function copyDiscountCode() {
  navigator.clipboard
    .writeText("RABATT10")
    .then(() => {
      var successMessage = document.getElementById(
        "ph-discount-code-success-message"
      );
      successMessage.style.display = "block";

      setTimeout(() => {
        successMessage.style.display = "none";
      }, 2000);
    })
    .catch((err) => {});
}

/** Collapse prouct description if too long */
document.addEventListener("DOMContentLoaded", function () {
  var container = document.querySelector(".ph-pdp-description");
  var content = document.querySelector(".ph-pdp-description .product");

  if (container && content) {
    if (content.scrollHeight > container.clientHeight) {
      var toggleButton = document.createElement("button");
      toggleButton.textContent = `Mehr zeigen`;
      toggleButton.classList.add("pho-product-description-toggle-button");

      container.insertAdjacentElement("afterend", toggleButton);

      toggleButton.addEventListener("click", function () {
        container.classList.toggle("expanded");

        if (container.classList.contains("expanded")) {
          toggleButton.textContent = "Weniger zeigen";
          toggleButton.classList.add("open");
        } else {
          toggleButton.textContent = "Mehr zeigen";
          toggleButton.classList.remove("open");
        }
      });
    }
  }
});

/**
  document.addEventListener("DOMContentLoaded", function () {
  //var variantsSelectTags = document.getElementsByTagName("variant-selects");
  var variantsSelectTagContainer = document.querySelector("section.product__info-container");
  console.log(variantsSelectTagContainer);

  function handleScriptTagChange() {
    var scriptTag = document.querySelector("script[data-selected-variant]");

    if (scriptTag) {
      try {
        var productData = JSON.parse(scriptTag.textContent);
        var sizeInformationJson = document.getElementById(
          "pho-size-information-json"
        );


        if (sizeInformationJson) {
          console.log('size');
          sizeInformationData = JSON.parse(sizeInformationJson.textContent);

          if (sizeInformationData[productData.option2]) {
            console.log('size2');
            console.log(sizeInformationData[productData.option2]);
            document.querySelector(".pho-size-information").textContent =
              "Größe: " + sizeInformationData[productData.option2];
          }
        }
      } catch (e) {}
    } else {
    }
  }

  if (variantsSelectTagContainer) {

    var observer = new MutationObserver(function (mutationsList) {
      for (var mutation of mutationsList) {
        if (mutation.type === "childList") {
          handleScriptTagChange();
        }
      }
    });

    observer.observe(variantsSelectTagContainer, { childList: true, subtree: true });
    handleScriptTagChange();
  }
});
*/
